export const COOKIE_ACCEPTANCE_KEY = 'cookies_allowed';
export const COOKIE_ACCEPTANCE_EXPIRE = 365;
export const COOKIE_GRATEFUL_USER_INFO_MODAL = 'grateful_introduction_showned';
export const COOKIE_HAVE_OPENED_SAVE_MODAL = 'have_opened_save_modal';
export const COOKIE_COUNTER_DEAL_VISITS = 'counter_deal_visits';
export const COOKIE_UNLOGGED_ID_KEY = 'visitor_id';
